import { type BrokersBrokerAttentionNeededItemStatus } from 'utils/web_api.schemas'
export const StatusCell = ({ value } : { value: BrokersBrokerAttentionNeededItemStatus }) => {
  let color = ''
  let label = ''
  switch (value) {
    case 'active':
      color = 'text-red-500'
      label = 'Active'
      break
    case 'silenced':
      color = 'text-yellow-500'
      label = 'Silenced'
      break
    case 'resolved':
      color = 'text-green-400'
      label = 'Resolved'
      break
    default:
      color = 'text-gray-500'
      label = 'Unknown'
  }
  return <p className={`${color}`}>{label}</p>
}
